var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    height: "256px",
    width: "256px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-51.2 -51.2 614.40 614.40",
    xmlSpace: "preserve",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("rect", {
    x: -51.2,
    y: -51.2,
    width: 614.4,
    height: 614.4,
    rx: 0,
    fill: "#000000",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M473.6,390.4V275.2h25.6L443.734,224H480c10.604,0,19.2-8.596,19.2-19.2s-8.596-19.2-19.2-19.2h-38.4 c10.604,0,19.2-8.596,19.2-19.2s-8.596-19.2-19.2-19.2h-81.066L332.8,121.6l-54.693,50.486 c-8.639-22.353-28.563-52.339-73.864-57.929c-6.78-0.836-13.034-0.664-18.769,0.224c-3.572-4.572-8.013-8.982-13.527-13.014 c-60.067-43.918-115.384,5.595-115.384,5.595c32.087-0.353,53.771,8.333,68.387,19.61c-12.068-0.957-25.929-0.143-41.111,3.999 C0.453,153.331,0,252.111,0,252.111c36.63-43.596,76.402-50.926,105.141-48.509c-1.668,8.988,2.131,18.139,9.585,23.341 l-2.583,36.242l-13-1.521l5.029,62.072H93.507L106.84,390.4H51.2v38.4H512v-38.4H473.6z M192,275.2v115.2h-58.495l13.334-66.664 h-12.865l18.136-55.872l-11.799-1.381l12.104-24.074c0.746,0.396,1.518,0.759,2.321,1.076c10.545,4.175,22.308,0.127,28.212-9.073 c4.6,3.645,9.253,7.901,13.727,12.842L166.4,275.2H192z M221.243,164.707c13.594,1.32,29.039,6.331,45.526,17.846l-16.893,15.594 c-0.46-0.794-0.918-1.586-1.404-2.38C240.242,182.351,230.694,172.269,221.243,164.707z M268.8,351.999h-38.4v-38.4h38.4V351.999z M358.4,390.399h-51.2v-76.8h51.2V390.399z M435.2,351.999h-38.4v-38.4h38.4V351.999z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerks);
export default __webpack_public_path__ + "static/media/Perks.3b387c900d391f01af9be26d3a5869f8.svg";
export { ForwardRef as ReactComponent };